import { createAction, handleActions } from 'redux-actions'
import { sendApiRequest, sendApiFileRequest } from 'utils/api'
import { getClientId } from 'utils/utils'

export const GET_FOLDERS = 'GET_FOLDERS'
export const getFolders = () => {
  return (dispatch, getState) => {
    dispatch(createAction(GET_FOLDERS)())
    const clientId = getClientId(getState)
    const options = {
      filter: {
        order: 'updatedOn DESC',
        where: {
          clientId
        },
        include: ['documents']
      }
    }
    sendApiRequest('Folders', {
      accessToken: getState().auth.account.accessToken
    }, 'get', options).then((response) => {
      if (response.status === 'failure') {
        dispatch(getFoldersError(response))
      }
      if (response.status === 'success') {
        dispatch(getFoldersSuccess(response.data))
      }
    })
  }
}

export const GET_FOLDERS_SUCCESS = 'GET_FOLDERS_SUCCESS'
export const getFoldersSuccess = createAction(GET_FOLDERS_SUCCESS)

export const GET_FOLDERS_ERROR = 'GET_FOLDERS_ERROR'
export const getFoldersError = createAction(GET_FOLDERS_ERROR)

export const DELETE_FOLDER_BY_ID = 'DELETE_FOLDER_BY_ID'
export const deleteFolderById = (id) => {
  return (dispatch, getState) => {
    dispatch(createAction(DELETE_FOLDER_BY_ID)())
    sendApiRequest(`Folders/${id}`, {
      accessToken: getState().auth.account.accessToken
    }, 'delete').then((response) => {
      if (response.status === 'failure') {
        dispatch(deleteFolderByIdError(response.data))
      }
      if (response.status === 'success') {
        dispatch(deleteFolderByIdSuccess(response.data))
      }
    })
  }
}

export const DELETE_FOLDER_BY_ID_SUCCESS = 'DELETE_FOLDER_BY_ID_SUCCESS'
export const deleteFolderByIdSuccess = createAction(DELETE_FOLDER_BY_ID_SUCCESS)

export const DELETE_FOLDER_BY_ID_ERROR = 'DELETE_FOLDER_BY_ID_ERROR'
export const deleteFolderByIdError = createAction(DELETE_FOLDER_BY_ID_ERROR)

export const DELETE_FOLDER_BY_ID_RESET = 'DELETE_FOLDER_BY_ID_RESET'
export const deleteFolderByIdReset = createAction(DELETE_FOLDER_BY_ID_RESET)

export const OPEN_FOLDER_DIALOG = 'OPEN_FOLDER_DIALOG'
export const openFolderDialog = createAction(OPEN_FOLDER_DIALOG)

export const CLOSE_FOLDER_DIALOG = 'CLOSE_FOLDER_DIALOG'
export const closeFolderDialog = createAction(CLOSE_FOLDER_DIALOG)

export const OPEN_EDIT_FOLDER_DIALOG = 'OPEN_EDIT_FOLDER_DIALOG'
export const openEditFolderDialog = createAction(OPEN_EDIT_FOLDER_DIALOG)

export const CLOSE_EDIT_FOLDER_DIALOG = 'CLOSE_EDIT_FOLDER_DIALOG'
export const closeEditFolderDialog = createAction(CLOSE_EDIT_FOLDER_DIALOG)

export const CREATE_NEW_FOLDER = 'CREATE_NEW_FOLDER'
export const createNewFolder = (data) => {
  return (dispatch, getState) => {
    dispatch(createAction(CREATE_NEW_FOLDER)())
    const folderData = data
    const clientId = getClientId(getState)
    folderData.accessToken = getState().auth.account.accessToken
    folderData.clientId = clientId
    folderData.createdOn = new Date()
    folderData.createdBy = getState().auth.user.userId
    folderData.updatedOn = new Date()
    folderData.updatedBy = getState().auth.user.userId
    sendApiRequest('Folders', folderData, 'post').then((response) => {
      if (response.status === 'failure') {
        dispatch(createNewFolderError(response))
      }
      if (response.status === 'success') {
        dispatch(createNewFolderSuccess(response.data))
        dispatch(getFolders())
      }
    })
  }
}

export const CREATE_NEW_FOLDER_SUCCESS = 'CREATE_NEW_FOLDER_SUCCESS'
export const createNewFolderSuccess = createAction(CREATE_NEW_FOLDER_SUCCESS)

export const CREATE_NEW_FOLDER_ERROR = 'CREATE_NEW_FOLDER_ERROR'
export const createNewFolderError = createAction(CREATE_NEW_FOLDER_ERROR)

export const RESET_FOLDER_FORM = 'RESET_FOLDER_FORM'
export const resetFolderForm = createAction(RESET_FOLDER_FORM)

export const OPEN_DOCUMENT_DIALOG = 'OPEN_DOCUMENT_DIALOG'
export const openDocumentDialog = createAction(OPEN_DOCUMENT_DIALOG)

export const CLOSE_DOCUMENT_DIALOG = 'CLOSE_DOCUMENT_DIALOG'
export const closeDocumentDialog = createAction(CLOSE_DOCUMENT_DIALOG)

export const RESET_DOCUMENT_FORM = 'RESET_DOCUMENT_FORM'
export const resetDocumentForm = createAction(RESET_DOCUMENT_FORM)

export const UPLOAD_DOCUMENT_FILES = 'UPLOAD_DOCUMENT_FILES'
export const uploadDocumentFiles = (data) => {
  return (dispatch, getState) => {
    dispatch(createAction(UPLOAD_DOCUMENT_FILES)())
    const documentData = new FormData()
    const clientId = getClientId(getState)
    Object.keys(data.files).forEach((key) => {
      documentData.append('file', data.files[key], data.files[key].name)
    })
    documentData.append('clientId', clientId)
    documentData.append('folder', data.folder)
    documentData.append('accessToken', getState().auth.account.accessToken)
    documentData.append('createdBy', getState().auth.user.userId)
    documentData.append('createdOn', new Date())
    documentData.accessToken = getState().auth.account.accessToken
    documentData.clientId = clientId
    documentData.createdOn = new Date()
    documentData.createdBy = getState().auth.user.userId
    sendApiFileRequest('Documents/upload', documentData, 'post')
      .then((response) => {
        if (response.status === 'failure') {
          dispatch(uploadDocumentFilesError(response.data))
        }
        if (response.status === 'success') {
          dispatch(uploadDocumentFilesSuccess(response.data))
        }
      })
  }
}

export const UPLOAD_DOCUMENT_FILES_SUCCESS = 'UPLOAD_DOCUMENT_FILES_SUCCESS'
export const uploadDocumentFilesSuccess = createAction(UPLOAD_DOCUMENT_FILES_SUCCESS)

export const UPLOAD_DOCUMENT_FILES_ERROR = 'UPLOAD_DOCUMENT_FILES_ERROR'
export const uploadDocumentFilesError = createAction(UPLOAD_DOCUMENT_FILES_ERROR)

export const DELETE_DOCUMENT_BY_ID = 'DELETE_DOCUMENT_BY_ID'
export const deleteDocumentById = (id) => {
  return (dispatch, getState) => {
    dispatch(createAction(DELETE_DOCUMENT_BY_ID)())
    sendApiRequest(`Documents/${id}`, {
      accessToken: getState().auth.account.accessToken
    }, 'delete').then((response) => {
      if (response.status === 'failure') {
        dispatch(deleteDocumentByIdError(response.data))
      }
      if (response.status === 'success') {
        dispatch(deleteDocumentByIdSuccess(response.data))
      }
    })
  }
}

export const DELETE_DOCUMENT_BY_ID_SUCCESS = 'DELETE_DOCUMENT_BY_ID_SUCCESS'
export const deleteDocumentByIdSuccess = createAction(DELETE_DOCUMENT_BY_ID_SUCCESS)

export const DELETE_DOCUMENT_BY_ID_ERROR = 'DELETE_DOCUMENT_BY_ID_ERROR'
export const deleteDocumentByIdError = createAction(DELETE_DOCUMENT_BY_ID_ERROR)

export const DELETE_DOCUMENT_BY_ID_RESET = 'DELETE_DOCUMENT_BY_ID_RESET'
export const deleteDocumentByIdReset = createAction(DELETE_DOCUMENT_BY_ID_RESET)

export const UPDATE_FOLDER_BY_ID = 'UPDATE_FOLDER_BY_ID'
export const updateFolderById = (data) => {
  return (dispatch, getState) => {
    dispatch(createAction(UPDATE_FOLDER_BY_ID)())
    const folderData = data
    folderData.accessToken = getState().auth.account.accessToken
    sendApiRequest(`Folders/${data.id}`, data, 'patch').then((response) => {
      if (response.status === 'failure') {
        dispatch(updateFolderByIdError(response.data))
      }
      if (response.status === 'success') {
        dispatch(updateFolderByIdSuccess(response.data))
      }
    })
  }
}

export const UPDATE_FOLDER_BY_ID_SUCCESS = 'UPDATE_FOLDER_BY_ID_SUCCESS'
export const updateFolderByIdSuccess = createAction(UPDATE_FOLDER_BY_ID_SUCCESS)

export const UPDATE_FOLDER_BY_ID_ERROR = 'UPDATE_FOLDER_BY_ID_ERROR'
export const updateFolderByIdError = createAction(UPDATE_FOLDER_BY_ID_ERROR)

export const UPDATE_FOLDER_BY_ID_RESET = 'UPDATE_FOLDER_BY_ID_RESET'
export const updateFolderByIdReset = createAction(UPDATE_FOLDER_BY_ID_RESET)

const initialState = {
  folders: [],
  isGettingFolders: false,
  hasGottenFolders: false,
  getFoldersError: {},
  getFoldersSuccess: {},
  isDeletingFolder: false,
  hasDeletedFolder: false,
  deleteFolderError: {},
  deleteFolderSuccess: {},
  folderDialogIsOpen: false,
  editFolderDialogIsOpen: false,
  selectedFolderToEdit: {},
  isEditingFolder: false,
  editFolderSuccess: {},
  documentDialogIsOpen: false,
  isDeletingDocument: false,
  hasDeletedDocument: false,
  deleteDocumentError: {},
  deleteDocumentSuccess: {},
  isUploadingDocuments: false,
  hasUploadedDocuments: false,
  uploadDocumentsError: {},
  uploadDocumentsSuccess: {},
  isUpdatingFolder: false,
  hasUpdatedFolder: false,
  updateFolderError: {},
  updateFolderSuccess: {}
}

export default handleActions({

  [GET_FOLDERS]: (state) => ({
    ...state,
    isGettingFolders: true,
    hasGottenFolders: false
  }),

  [GET_FOLDERS_SUCCESS]: (state, { payload }) => {
    return {
      ...state,
      isGettingFolders: false,
      hasGottenFolders: true,
      folders: payload,
      getFoldersSuccess: {}
    }
  },

  [GET_FOLDERS_ERROR]: (state, { payload }) => {
    return {
      ...state,
      isGettingFolders: true,
      hasGottenFolders: false,
      getFoldersError: payload
    }
  },

  [OPEN_FOLDER_DIALOG]: (state, { payload }) => {
    return {
      ...state,
      folderDialogIsOpen: true,
      folderDialogRole: payload
    }
  },

  [CLOSE_FOLDER_DIALOG]: (state) => {
    return {
      ...state,
      folderDialogIsOpen: false,
      isCreatingFolder: false,
      hasCreatedFolder: false,
      createFolderSuccess: {},
      createFolderError: {}
    }
  },

  [OPEN_EDIT_FOLDER_DIALOG]: (state, { payload }) => {
    return {
      ...state,
      editFolderDialogIsOpen: true,
      selectedFolderToEdit: payload
    }
  },

  [CLOSE_EDIT_FOLDER_DIALOG]: (state) => {
    return {
      ...state,
      editFolderDialogIsOpen: false,
      selectedFolderToEdit: {},
      isEditingFolder: true,
      hasEditedFolder: false,
      editFolderSuccess: {},
      selectedFolderPermissions: []
    }
  },

  [DELETE_FOLDER_BY_ID]: (state) => ({
    ...state,
    isDeletingFolder: true,
    hasDeletedFolder: false
  }),

  [DELETE_FOLDER_BY_ID_SUCCESS]: (state, { payload }) => {
    return {
      ...state,
      isDeletingFolder: false,
      hasDeletedFolder: true,
      deleteFolderSuccess: payload
    }
  },

  [DELETE_FOLDER_BY_ID_ERROR]: (state, { payload }) => {
    return {
      ...state,
      isDeletingFolder: false,
      hasDeletedFolder: false,
      deleteFolderError: payload
    }
  },

  [DELETE_FOLDER_BY_ID_RESET]: (state) => {
    return {
      ...state,
      isDeletingFolder: false,
      hasDeletedFolder: false,
      deleteFolderError: {},
      deleteFolderSuccess: {}
    }
  },

  [OPEN_FOLDER_DIALOG]: (state, { payload }) => {
    return {
      ...state,
      folderDialogIsOpen: true,
      folderDialogRole: payload
    }
  },

  [CLOSE_FOLDER_DIALOG]: (state) => {
    return {
      ...state,
      folderDialogIsOpen: false,
      isCreatingFolder: false,
      hasCreatedFolder: false,
      createFolderSuccess: {},
      createFolderError: {}
    }
  },

  [RESET_FOLDER_FORM]: (state) => {
    return {
      ...state,
      isCreatingFolder: false,
      hasCreatedFolder: false,
      createFolderSuccess: {},
      createFolderError: {}
    }
  },

  [CREATE_NEW_FOLDER]: (state) => {
    return {
      ...state,
      isCreatingFolder: true,
      hasCreatedFolder: false,
      createFolderSuccess: {},
      createFolderError: {}
    }
  },

  [CREATE_NEW_FOLDER_SUCCESS]: (state, { payload }) => {
    return {
      ...state,
      isCreatingFolder: false,
      hasCreatedFolder: true,
      createFolderSuccess: payload
    }
  },

  [CREATE_NEW_FOLDER_ERROR]: (state, { payload }) => {
    return {
      ...state,
      isCreatingFolder: false,
      hasCreatedFolder: false,
      createFolderError: payload
    }
  },

  [OPEN_DOCUMENT_DIALOG]: (state) => {
    return {
      ...state,
      documentDialogIsOpen: true
    }
  },

  [CLOSE_DOCUMENT_DIALOG]: (state) => {
    return {
      ...state,
      documentDialogIsOpen: false,
      isCreatingDocument: false,
      hasCreatedDocument: false,
      createDocumentSuccess: {},
      createDocumentError: {}
    }
  },

  [RESET_DOCUMENT_FORM]: (state) => {
    return {
      ...state,
      isCreatingDocument: false,
      hasCreatedDocument: false,
      createDocumentSuccess: {},
      createDocumentError: {}
    }
  },

  [DELETE_DOCUMENT_BY_ID]: (state) => ({
    ...state,
    isDeletingDocument: true,
    hasDeletedDocument: false
  }),

  [DELETE_DOCUMENT_BY_ID_SUCCESS]: (state, { payload }) => {
    return {
      ...state,
      isDeletingDocument: false,
      hasDeletedDocument: true,
      deleteDocumentSuccess: payload
    }
  },

  [DELETE_DOCUMENT_BY_ID_ERROR]: (state, { payload }) => {
    return {
      ...state,
      isDeletingDocument: false,
      hasDeletedDocument: false,
      deleteDocumentError: payload
    }
  },

  [DELETE_DOCUMENT_BY_ID_RESET]: (state) => {
    return {
      ...state,
      isDeletingDocument: false,
      hasDeletedDocument: false,
      deleteDocumentError: {},
      deleteDocumentSuccess: {}
    }
  },

  [UPLOAD_DOCUMENT_FILES]: (state) => {
    return {
      ...state,
      isUploadingDocuments: true,
      hasUploadedDocuments: false,
      uploadDocumentsError: {},
      uploadDocumentsSuccess: {}
    }
  },

  [UPLOAD_DOCUMENT_FILES_SUCCESS]: (state, { payload }) => {
    return {
      ...state,
      isUploadingDocuments: false,
      hasUploadedDocuments: true,
      uploadDocumentsError: {},
      uploadDocumentsSuccess: payload
    }
  },

  [UPLOAD_DOCUMENT_FILES_ERROR]: (state, { payload }) => {
    return {
      ...state,
      isUploadingDocuments: false,
      hasUploadedDocuments: false,
      uploadDocumentsError: payload,
      uploadDocumentsSuccess: {}
    }
  },

  [RESET_DOCUMENT_FORM]: (state) => {
    return {
      ...state,
      isUploadingDocuments: false,
      hasUploadedDocuments: false,
      uploadDocumentsError: {},
      uploadDocumentsSuccess: {}
    }
  },

  [UPDATE_FOLDER_BY_ID]: (state) => ({
    ...state,
    isUpdatingFolder: true,
    hasUpdatedFolder: false,
  }),

  [UPDATE_FOLDER_BY_ID_SUCCESS]: (state, { payload }) => {
    return {
      ...state,
      isUpdatingFolder: false,
      hasUpdatedFolder: true,
      updateFolderSuccess: payload
    }
  },

  [UPDATE_FOLDER_BY_ID_ERROR]: (state, { payload }) => {
    return {
      ...state,
      isUpdatingFolder: false,
      hasUpdatedFolder: false,
      updateFolderError: payload
    }
  },

  [UPDATE_FOLDER_BY_ID_RESET]: (state) => {
    return {
      ...state,
      isUpdatingFolder: false,
      hasUpdatedFolder: false,
      updateFolderError: {},
      updateFolderSuccess: {}
    }
  },

}, initialState)
